
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h4>{`Szenario A: Ohne «SwissCovid» App`}</h4>
    <p>{`Die von Ihnen angesteckten Personen sind immer noch ohne Symptome. Die meisten
wissen nichts von ihrer Gefährlichkeit und `}<strong parentName="p">{`verbreiten das Virus weiter`}</strong>{`. Seit
Ihrer ursprünglichen Ansteckung ist bereits eine Woche vergangen.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;